module.exports = __webpack_public_path__ + "fonts/PRmiXeptR36kaC0GEAetxiJ0caWjaSBdV-xZbEgst_k.woff2";